import * as React from 'react';
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Stack } from '@mui/system';
import { IoMdClose } from "react-icons/io";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';


export default function StatementStatusDialog(props) {

    console.log("props", props);

    function formatDate(dateString) {
        const date = new Date(dateString);

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;


        return `${formattedDate}`;
    }

    //   function formatTime(dateString) {
    //     const date = new Date(dateString);
    //     let hours = date.getHours();
    //     const minutes = date.getMinutes().toString().padStart(2, '0');
    //     const seconds = date.getSeconds().toString().padStart(2, '0');
    //     const ampm = hours >= 12 ? 'PM' : 'AM';
    //     hours = hours % 12 || 12;
    //     const formattedHours = hours.toString().padStart(2, '0');
    //     const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
    //     return `${formattedTime}`;
    //   }



    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <Box sx={{ position: 'absolute', top: 10, right: 10, fontSize: '18px', cursor: 'pointer' }} onClick={props.handleClose}>
                    <IoMdClose />
                </Box>
                <DialogTitle id="alert-dialog-title">
                </DialogTitle>
                <DialogContent>
                    <Stack gap={1}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant='h4'>Topup Request</Typography>
                            <Typography variant='h4'>AI Status: {props.data && props.data.ai_status ? props.data.ai_status : "Pending"}</Typography>
                        </Stack>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ maxWidth: 300 }}>Reference ID</TableCell>
                                        <TableCell align="right">Amount</TableCell>
                                        <TableCell align="right">Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell sx={{ maxWidth: 300 }} component="th" scope="row">
                                            {props.data && props.data.ref1 ? props.data.ref1 : "-"}
                                        </TableCell>
                                        <TableCell align="right">{props.data ? props.data.topupamount : "-"}</TableCell>
                                        <TableCell align="right">{props.data ? formatDate(props.data.createddate) : "-"}</TableCell>

                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Typography variant='h4'>Bank Statement</Typography>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ maxWidth: 300 }}>Reference ID</TableCell>
                                        <TableCell align="center">Amount</TableCell>
                                        <TableCell align="right">Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell
                                            sx={{
                                                maxWidth: '100%',
                                                wordBreak: 'break-word',
                                                whiteSpace: 'normal',
                                                padding: '8px',
                                                lineHeight: 1.5,
                                            }}
                                            component="th"
                                            scope="row"
                                        >
                                            <Box sx={{  height: 'auto', wordWrap: 'break-word'}}>
                                                <td style={{wordWrap:'break-word',width:'100%',overflowWrap:'break-word'}}>{props.data && props.data.bank_statement && props.data.bank_statement !== " "
                                                    ? props.data.bank_statement.split("^-^")[0]
                                                    : "-"
                                                }</td>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center">{props.data && props.data.bank_statement && props.data.bank_statement !== " " ? props.data.bank_statement.split("^-^")[1] : "-"}</TableCell>
                                        <TableCell align="right">
                                            {props.data  && props.data.bank_statement && props.data.bank_statement !== " "
                                                ? props.data.bank_statement.split("^-^")[2]
                                                : "-"
                                            }
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Stack>
                </DialogContent>
                {/* <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button disabled={props.isLoading ? true : false} variant='contained' color='secondary' onClick={props.handleSubmit}>asdasd</Button>

                </DialogActions> */}
            </Dialog>
        </React.Fragment>
    );
}
